{
  "portalHost": "portal.swaggerhub.com",
  "platform": {
    "subscriptionsUrl": "/organizations/{organizationId}/subscriptions",
    "modifySubscriptionUrl": "/organizations/{organizationId}/subscriptions/{subscriptionId}/modify",
    "membersUrl": "/organizations/{organizationId}/members"
  },
  "contactUrl": "https://swagger.io/tools/swaggerhub/contact-us/",
  "registryUrlSuffixes": ["swagger.json", "json", "swagger.yaml", "yaml"],
  "support": {
    "supportRequest": "https://support.smartbear.com/swagger/message"
  }
}
